import {Component, Input, OnInit} from '@angular/core';
import {PaymentService} from '@services/payment/payment.service';
import {SubscriptionService} from '@services/subscription/subscription.service';
import * as moment from 'moment';
import {MatDialog} from '@angular/material';
import {PutToBalanceComponent} from '../../../../components/put-to-balance/put-to-balance.component';
import {BehaviorSubject, Subject} from '@node_modules/rxjs';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';

import {User} from '@models/user';

@Component({
  selector: 'app-payments-page',
  templateUrl: './payments-page.component.html',
  styleUrls: ['./payments-page.component.scss']
})
export class PaymentsPageComponent implements OnInit {
  putMoneyModal;
  payments = false;
  monthPayments = [];
  monthSum = [];
  currMonth = [];
  firstRun = true;
  @Input() refresh: BehaviorSubject<string>;
  @Input() user: User;
  @Input() embeddedInStudentMemberships = false;

  currentMonth = moment();
  authUser = null;
  isDarkTheme = false;
  checkedMonth = '';
  name = '';
  amount: number;
  hours = '';
  start_work_at = '';
  description = '';
  worked = '1 hour';

  months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  displayedColumns: string[] = ['date', 'program', 'time', 'worked', 'earned'];
  movePaymentsCarousel: Subject<string> = new BehaviorSubject(null);
  moveAttendencesCarousel: Subject<string> = new BehaviorSubject(null);
  overduePayments: {name?: string, amount?: string, program_id: number, subscription_id: number}[];
  nextPayments: {name: string, date: {date: string}, amount: number, subscription_id: number}[];
  previousPayments: {name: string, date: {date: string}, amount: number, status: string}[];
  constructor(
    public dialog: MatDialog,
    private paymentService: PaymentService,
    private subscriptionService: SubscriptionService,
    private authStore: Store<AuthReducer.AuthState>
  ) { }

  get nextPaymentsTabLabel(): string {
    return this.embeddedInStudentMemberships ? 'Scheduled' : 'Next Payments';
  }

  get previousPaymentsTabLabel(): string {
    return this.embeddedInStudentMemberships ? 'History' : 'Previous Payments';
  }

  /**
   *  Iteration 1044: the top-level `/payments` route never binds `[user]`
   *  (it is rendered directly by the router with no wrapping template), so
   *  the pre-existing `user && user.role === 'teacher'`/`!== 'teacher'`
   *  branches below never resolve there — only `authUser` (set from the
   *  auth store, always populated) does. This getter is the only thing that
   *  decides whether the new Teacher placeholder renders; it prefers the
   *  `@Input() user` (the embedded-in-Student-Memberships case, unchanged)
   *  and falls back to `authUser` so the same placeholder also renders on
   *  the real routed page. It does not alter the existing
   *  `user.role !== 'teacher'` condition or content at all.
   */
  get isTeacherPlaceholderView(): boolean {
    const role = (this.user && this.user.role) || (this.authUser && this.authUser.role);
    return role === 'teacher';
  }

  /**
   *  Iteration 1045: on the direct `/payments` route `@Input() user` is never
   *  bound (proven in Iteration 1044 — no wrapping template can set it), so
   *  the legacy `this.getPayments()` call below used to unconditionally
   *  dereference `this.user.id` on an `undefined` `user`, throwing a
   *  synchronous TypeError out of `ngOnInit()` during route activation. With
   *  no custom Router `errorHandler` configured (confirmed in
   *  `app-routing.module.ts`) and no `NavigationError` handling anywhere in
   *  the app, the Router silently treated that as a failed navigation
   *  transition while the view had already been inserted — producing the
   *  inconsistent/slow-to-settle `/payments` loads reported. `authUser` is
   *  populated synchronously by the `authStore.subscribe` call just above
   *  (ngrx v6 replays current state to new subscribers), so
   *  `isTeacherPlaceholderView` is safe to read immediately after it.
   *
   *  Gating below: the Teacher placeholder never needs and must never
   *  trigger legacy payment/payout calls or touch `this.user.id`. The
   *  existing embedded Student/Admin initialization (`this.user` bound,
   *  role !== 'teacher') is preserved exactly, unreached by the placeholder
   *  branch. A bare, unbound, non-Teacher direct hit (e.g. Student's
   *  `goToMembershipPage()`) now safely no-ops instead of throwing, with no
   *  change to what it visually renders (still nothing, as before).
   */
  ngOnInit() {
    this.isDarkTheme = localStorage.getItem('mkc-dashboard-theme') === 'dark';
    this.applyTheme();

    this.authStore.subscribe(
        (val) => {
          const auth = val.auth;
          if (auth && auth.user) {
            this.authUser = auth.user;
          }
        }
    );

    if (this.isTeacherPlaceholderView) {
      return;
    }

    if (!this.user) {
      return;
    }

    this.getPayments();
    this.getPayoutList();
    if (this.user.role !== 'teacher') {
      this.refresh.subscribe(v => {
        this.paymentsRefresh();
      });
    }
  }

  getPayments() {
    this.paymentService.getPaymentsInformation(this.user.id).subscribe(
        (resp: {data: any}) => {
          this.overduePayments = resp.data.overduePayments;
          this.nextPayments = resp.data.nextPayments;
          this.previousPayments = resp.data.previousPayments;
          // if (this.overduePayments && this.overduePayments.length) {
          //   this.overduePayments.map( (item) => {
          //     this.payForSubscription(item.program_id, item.subscription_id);
          //   });
          // }
        }
    );
  }

  paymentsRefresh() {
    if (!this.firstRun) {
      this.getPayments();
    }
    this.firstRun = false;
  }

  getDiscount(subscription_id, withPrice = false) {
    let discount = null;

    if (this.user.subscriptions) {
      this.user.subscriptions.map(item => {

        if (+item.userSubscriptionId === +subscription_id) {
          if (!withPrice) {
            discount = item.discount_value;
          } else {
            discount = '' + item.paymentPriceWithDiscount;
          }
        }
      });
    }

    return discount;
  }

  getDiscountValueName(subscription_id) {
    let discountValueName = null;
    this.user.subscriptions.map( item => {
      if (item.userSubscriptionId === subscription_id) {
        discountValueName = item.discount_value_mark;
      }
    });
    return discountValueName;
  }

  setDiscount(inputId, subscription_id, selectId) {
    const input = document.getElementById(inputId) as HTMLInputElement;
    const select = document.getElementById(selectId) as HTMLSelectElement;
    if (input && select) {
      const newDiscount = input.value;
      const discountValueName = select.value;
      this.user.subscriptions.map((item, i) => {
        if (item.id === subscription_id) {
          const data = {
            user_subscription_id: item.userSubscriptionId,
            discount_value: +newDiscount,
            discount_value_name: discountValueName
          };
          this.subscriptionService.editUserSubscription(data).subscribe(
              resp => {
                this.paymentService.getDiscount({
                  'subscription_id': item.id,
                  'userSubscription_id': item.userSubscriptionId,
                  'price': item.payment_price
                }).subscribe(
                    (resp: {data: number}) => this.user.subscriptions[i].paymentPriceWithDiscount = resp.data
                );
              }
          );
        }
      });
    }
  }

  payForSubscription(program_id, subscription_id) {
    this.paymentService.createChargeForProgram(program_id, subscription_id).subscribe(
      (resp: {data: any}) => {
        if (resp.data.status === 'redirect' && resp.data.url && resp.data.url.length > 0) {
          document.location.replace(resp.data.url);
        } else {
          this.overduePayments.map( (item, i) => {
            if (item.program_id === program_id && item.subscription_id === subscription_id) {
              this.overduePayments.splice(i, 1);
            }
          });
          this.previousPayments.push(resp.data);
        }
      }
    );
  }
  getOverdueMessage(overduePayment) {
    return `Need to pay ${overduePayment.amount} for subscritpoion with name ${overduePayment.name}`;
  }
  getFormatedDate(date) {
    return moment(date).format('ll');
  }
  openPutMoneyModal() {
    this.putMoneyModal = this.dialog.open(PutToBalanceComponent);
    PutToBalanceComponent.dialogRef = this.putMoneyModal;
  }
  monthReport(selectedMonth) {
    this.paymentService.getPeyoutsList(this.user.id).subscribe(
      (resp: {data: any}) => {
        this.monthPayments = resp.data[selectedMonth];
        // console.log(resp.data, selectedMonth, resp.data[selectedMonth]);
        // if (this.monthPayments) {
        //   for (let i = 0; i < this.monthPayments.length; i++ ) {
        //     const obj = this.monthPayments[i];
        //     for (const description in obj) {
        //       if (obj.hasOwnProperty(description)) {
        //         if (description != null) {
        //           this.description = obj[description];
        //         } else {
        //           this.description = 'No description';
        //         }
        //       }
        //     }
        //     for (const amount in obj) {
        //       if (obj.hasOwnProperty(amount)) {
        //         this.amount = parseInt(obj[amount], 10);
        //       }
        //     }
        //     for (const start_work_at in obj) {
        //       if (obj.hasOwnProperty(start_work_at)) {
        //         this.start_work_at = obj[start_work_at];
        //       }
        //     }
        //   }
        // } else {
        //   console.log('No payments in this month');
        // }
      }
    );
  }
  totalEarned() {
    return this.monthPayments.reduce((acc, curr) => parseFloat(acc) + parseFloat(curr.amount), 0);
  }
  selectProgram(event) {
    this.monthReport(this.checkedMonth);
  }
  // getHeight() {
  //   console.log(this.monthPayments);
  // }
  getPayoutList() {
    this.paymentService.getPeyoutsList(this.user.id).subscribe(
      (resp: {data: any}) => {
        //
      }
    );
  }

  /**
   *  Established app-wide dark/light toggle mechanism (mirrors
   *  TeacherPageComponent/AttendancePageComponent byte-for-byte): reads and
   *  writes the same shared `mkc-dashboard-theme` localStorage key already
   *  used by `UserComponent`, so it does not introduce a second theme system.
   */
  setTheme(theme: 'light' | 'dark') {
    this.isDarkTheme = theme === 'dark';
    localStorage.setItem('mkc-dashboard-theme', theme);
    this.applyTheme();
  }

  private applyTheme() {
    const shell = document.getElementById('page-wrapper');
    if (shell) {
      shell.classList.toggle('theme-dark', this.isDarkTheme);
    }
    document.documentElement.classList.add('mkc-dashboard-shell');
    document.body.classList.add('mkc-dashboard-shell');
    document.documentElement.classList.toggle('mkc-theme-dark', this.isDarkTheme);
    document.body.classList.toggle('mkc-theme-dark', this.isDarkTheme);
  }

}
